import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import AccountServiceModel from '@/models/AccountServiceModel';

export enum ClientRequestStatusId {
	submitted = '1',
	inProgress = '2',
	resolved = '3',
	rejected = '4',
}

@model.cacheDuration()
@model.urnResource('client_request_status')
@doc.path('/client_request_statuses/{?id}')
export default class ClientRequestStatusModel extends AccountServiceModel {
	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Account_ClientRequestStatusReference;

	public get isOpen(): boolean {
		return this.reference === 'SUBMITTED' || this.reference === 'IN_PROGRESS';
	}

	public get pluralLabel(): string {
		switch (this.reference) {
			case 'SUBMITTED':
				return 'Soumises';
			case 'IN_PROGRESS':
				return 'En cours de traitement';
			case 'RESOLVED':
				return 'Traitées';
			case 'REJECTED':
				return 'Rejetées';
			default:
				return this.label;
		}
	}

	public get color() {
		switch (this.reference) {
			case 'SUBMITTED':
				return 'warning';
			case 'IN_PROGRESS':
				return 'processing';
			case 'RESOLVED':
				return 'success';
			case 'REJECTED':
				return 'error';
			default:
				return 'default';
		}
	}
}
